import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ChatAiModule } from '../../pages/chat-ai/chat-ai.module';
import { ChatFabComponent } from './chat-fab.component';

@NgModule({
  declarations: [ChatFabComponent],
  imports: [CommonModule, TranslateModule, ChatAiModule],
  exports: [ChatFabComponent],
})
export class ChatFabModule {}
